import { NodeViewProps } from '@tiptap/core'
import { NodeViewWrapper } from '@tiptap/react'
import React from 'react'
import { generateButtonStyles } from '../utils/generateButtonStyles'

const toCssProperties = (styles: string): Record<string, any> =>
  styles.split(';').reduce((acc: Record<string, any>, style: string) => {
    const [keyRaw, value] = style.split(':')
    const key = keyRaw.replace(/-./g, (m) => m[1].toUpperCase())
    if (key && value) acc[key.trim()] = value.trim()
    return acc
  }, {})

export const EditorButtonComponent = ({ node, selected }: NodeViewProps) => {
  const { url, text } = node.attrs
  return (
    <NodeViewWrapper
      className={`button-wrapper ${selected ? 'ProseMirror-selectednode' : ''}`.trim()}
      style={{
        display: 'flex',
        position: 'relative',
        maxWidth: '100%',
        width: '100%',
        maxHeight: '100%',
        borderRadius: '3px',
      }}
      draggable="true"
      data-drag-handle=""
    >
      <a
        href={url}
        style={{
          ...toCssProperties(generateButtonStyles(node.attrs)),
        }}
        onClick={(e) => e.preventDefault()}
      >
        {text}
      </a>
    </NodeViewWrapper>
  )
}
